import axios from "axios";

const axiosInstance = axios.create({
  // baseURL: "http://localhost:5000",
  baseURL: "https://api.lyvechat.ca",
});

export default axiosInstance;
